import { atomWithReset } from "jotai/utils";

export interface BatchAdjustForm {
  selecting: boolean;
  selectedIds: number[];
}

export const batchAdjustFormInitialValue: BatchAdjustForm = {
  selecting: false,
  selectedIds: [],
};

export const batchAdjustFormAtom = atomWithReset<BatchAdjustForm>(
  batchAdjustFormInitialValue,
);

export interface BatchAdjustTarget {
  codAgendamento: number;
  data: string;
  horaInicio: string;
  horaFim: string;
  nomePaciente: string;
  nomeUnidade: string;
  codUnidade: number;
  codCompromisso: number;
  codFormaRecebimento: number;
  recorrente: boolean;
}

export const batchAdjustTargetsAtom = atomWithReset<BatchAdjustTarget[]>([]);

export type BatchAdjustOrigin = "/calendar" | "/waiting-room";

export const batchAdjustOriginAtom = atomWithReset<BatchAdjustOrigin>("/calendar");

export const batchAdjustAppliedIdsAtom = atomWithReset<number[]>([]);
